// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608191020/js/" + chunkId + "." + {"44":"42cfd723","225":"d43fe7a1","481":"98a39007","486":"851cb721","770":"488515dd"}[chunkId] + ".0.24550677368539087.chunk.js";
};